













































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';
import restService from '@/services/restService';

import { PermissionEnum, RolePermission } from '@/models/DestinationRole';
import Schedule from '@/models/Schedule';

import ScheduleEditor from '@/components/Schedule/ScheduleEditor.vue';

@Component({
    components: {
      ScheduleEditor,
    },
})
export default class Schedules extends Vue {
  private loading: boolean = false;
  private schedules: Schedule[] = [];
  private error: string = '';
  private scheduleIndex: number = 0;

  @Prop({ required: true }) private passengerId: number;
  @Prop({ default: () => false }) private canEditSchedules: boolean;

  @Watch('passengerId', { immediate: true }) async onPassengerIdChanged() {
    if (this.passengerId) {
      await this.getPassengerSchedules(this.passengerId);
      if (this.schedules.length > 0) {
        this.scheduleIndex = this.getActiveScheduleIndex();
      }
    }
  }

  getActiveScheduleIndex() {
    if (this.schedules.length <= 1) {
      return 0;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const activeSchedule = this.schedules.find(s => {
      const start = new Date(s.startDate);
      start.setHours(0, 0, 0, 0);
      const end = new Date(s.endDate);
      end.setHours(0, 0, 0, 0);
      return start.getTime() <= today.getTime() && today.getTime() <= end.getTime();
    });

    if (!activeSchedule) {
      return this.schedules.length - 1;
    }

    return this.schedules.findIndex(s => s.id === activeSchedule.id);
  }

  previous() {
    const nextIndex = this.scheduleIndex - 1;
    this.scheduleIndex = nextIndex < 0 ? this.schedules.length - 1 : nextIndex;
  }

  next() {
    const nextIndex = this.scheduleIndex + 1;
    this.scheduleIndex = nextIndex === this.schedules.length ? 0 : nextIndex;
  }
  
  newSchedule() {
    const defaultSchedule = this.getDefaultSchedule();
    
    if (this.schedules.length > 0) {
      const previousSchedule = (JSON.parse(JSON.stringify(this.schedules)) as Schedule[])
        .sort((a, b) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime())[0];
      
      const previousDate = new Date(previousSchedule.endDate);
  
      const startDate = moment(new Date(previousDate).setDate(previousDate.getDate() + 1)).startOf('day').format('YYYY-MM-DD');
      const endDate = moment(startDate).add(1, 'days').startOf('day').format('YYYY-MM-DD');
  
      defaultSchedule.startDate = startDate;
      defaultSchedule.endDate = endDate;
    }

    this.schedules.push(defaultSchedule);
    this.scheduleIndex = this.schedules.length - 1;
  }

  handleCreatedSchedule(schedule: Schedule) {
    const scheduleIndex = this.schedules.findIndex(s => 
      s.id === 0 
      && new Date(s.startDate).getTime() === new Date(schedule.startDate).getTime() 
      && new Date(s.endDate).getTime() === new Date(schedule.endDate).getTime()
    );

    if (scheduleIndex > -1) {
      this.schedules.splice(scheduleIndex, 1, schedule);
      return;
    }

    this.schedules.push(schedule);
    this.scheduleIndex = this.schedules.length - 1;
  }

  handleSavedSchedule(schedule: Schedule) {
    const scheduleIndex = this.schedules.findIndex(s => s.id === schedule.id);
    this.schedules.splice(scheduleIndex, 1, schedule);
    this.scheduleIndex = scheduleIndex;
  }

  private async getPassengerSchedules(passengerId: number) {
    this.loading = true;
    try {
      const apiSchedules = await restService.schedules.getPassengerSchedules(passengerId);
      this.schedules = apiSchedules.map(s => new Schedule(s));
    } catch (error) {
      this.error = this.$t(
        'schedules.errors.passengerGet', 
        'Fetching schedules failed: {message}', 
        { message: (error as any).message }
      );
    } finally {
      this.loading = false;
    }
  }

  private getDefaultSchedule() {
    const schedule =  new Schedule(null);
    schedule.passengerId = this.passengerId;
    return schedule;
  }
}
